<template lang="pug">
  v-card.justify-center(style="border: solid;border-color: black;border-width: 1px;")
    v-card-title
      | {{data.title}}
      v-spacer
        v-icon(aria-label="Close" @click="$emit('close')")
          | mdi-close
    v-card-text.body-1.text-center
      v-row
        v-col(cols="12" md="12")
          p {{data.message}}
        v-col(cols="12" md="12")
          v-btn(color="primary" :to="'/dashboard/plans'") Actualizar plan
</template>

<script>

  export default {
    name: 'ValidateRestrictions',
    components: {
    },
    props: {
      data: {
        title: '',
        message: '',
      },
    },
    data: () => ({
    }),
    created () {
    },
    methods: {
    },
  }
</script>
